import {Typography} from "antd";

export const Home = () => {
  return <Typography.Title>Welcome to Calc</Typography.Title>;
};
